import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getUsers} from 'services/admin-data';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import User from 'typescript/models/User';

import {setListOfUsersAC} from '../pageEditorSlice';

export function* getPageEditorsSaga() {
  try {
    const response: AxiosResponse<ApiData<User[]>> = yield call(getUsers);

    const formattedUsers = response.data.data.map((user) => ({id: +user.id, name: user.attributes.email}));
    yield put(setListOfUsersAC(formattedUsers));
  } catch (error) {
    yield call(handleError, error, 'Could not get list of page editors');
  }
}
